var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!!_vm.selectedCruise)?_c('CruiseMapMask',{attrs:{"selectedCruise":_vm.selectedCruise,"lnglat":[_vm.selectedCruise.longitude, _vm.selectedCruise.latitude],"showDetailBtn":_vm.showDetailBtn},on:{"close":function($event){return _vm.$emit('update:selectedId', '')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }